import React, { useState } from 'react';
import { FolderPlus } from 'lucide-react';
import AddToPlaylistModal from './AddToPlaylistModal';

const AddToPlaylistButton = ({ movie, variant = 'icon', className = '' }) => {
    const [showModal, setShowModal] = useState(false);

    const handleClick = (e) => {
        e.stopPropagation(); // Empêcher la propagation pour ne pas ouvrir le film
        setShowModal(true);
    };

    const handleSuccess = () => {
        // Optionnel : notifier le parent
        console.log('Film ajouté à une playlist');
    };

    // Variante icône seule (pour les cartes)
    if (variant === 'icon') {
        return (
            <>
                <button
                    onClick={handleClick}
                    className={`p-2 bg-purple-600/20 hover:bg-purple-600/30 backdrop-blur-sm rounded-lg transition-all hover:scale-110 ${className}`}
                    title="Ajouter à une playlist"
                >
                    <FolderPlus className="w-4 h-4 text-purple-300" />
                </button>

                {showModal && (
                    <AddToPlaylistModal
                        movie={movie}
                        onClose={() => setShowModal(false)}
                        onSuccess={handleSuccess}
                    />
                )}
            </>
        );
    }

    // Variante bouton complet (pour le détail)
    if (variant === 'button') {
        return (
            <>
                <button
                    onClick={handleClick}
                    className={`flex items-center gap-2 px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-lg transition-all ${className}`}
                >
                    <FolderPlus className="w-5 h-5" />
                    <span>Ajouter à une playlist</span>
                </button>

                {showModal && (
                    <AddToPlaylistModal
                        movie={movie}
                        onClose={() => setShowModal(false)}
                        onSuccess={handleSuccess}
                    />
                )}
            </>
        );
    }

    // Variante petit bouton (pour les listes)
    if (variant === 'compact') {
        return (
            <>
                <button
                    onClick={handleClick}
                    className={`flex items-center gap-1 px-3 py-1.5 bg-white/10 hover:bg-white/20 text-gray-300 hover:text-white text-sm rounded-lg transition-all ${className}`}
                >
                    <FolderPlus className="w-4 h-4" />
                    <span>Playlist</span>
                </button>

                {showModal && (
                    <AddToPlaylistModal
                        movie={movie}
                        onClose={() => setShowModal(false)}
                        onSuccess={handleSuccess}
                    />
                )}
            </>
        );
    }

    return null;
};

export default AddToPlaylistButton;